<template>
  <v-container class="formulario-wrapper pt-4 px-3 mx-auto" fluid style="min-height: 80vh; max-width: 560px !important;">
    <v-row justify="center">
      <v-col cols="12" class="mt-2">
        <v-card class="elevation-2 rounded-lg overflow-hidden">

          <v-card-text class="py-2 px-4">
            <v-form ref="form" v-model="formValido">
              
              <!-- Seção 1: Identificação Básica -->
              <div class="d-flex align-center mb-2">
                <v-icon small color="primary" class="mr-2">mdi-card-bulleted-outline</v-icon>
                <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
                  IDENTIFICAÇÃO
                </span>
                <v-divider class="ml-3 divisor-secao"></v-divider>
              </div>

              <v-row dense>
                <!-- Placa com Botão de Busca integrado -->
                <v-col cols="10">
                  <v-text-field 
                    v-model="formData.placa"
                    v-mask="'XXX-XXXX'"
                    label="Placa" 
                    outlined dense hide-details 
                    @keydown.enter="buscarVeiculoPorPlacaDirect"
                    @blur="buscarVeiculoPorPlacaDirect"
                    @input="formData.placa = (formData.placa || '').toUpperCase()"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="d-flex justify-center">
                  <v-btn fab small color="primary" elevation="1" @click="pesquisarVeiculo" title="Pesquisar Veículo">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <v-text-field 
                    v-model="formData.descricao"
                    label="Descrição" 
                    outlined dense
                    hide-details="auto"
                    :rules="[v => !!v || 'Descrição é obrigatória']"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="formData.frota"
                    label="Frota"
                    outlined dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <v-col cols="4">
                  <v-text-field
                    v-model="formData.cor"
                    label="Cor"
                    outlined dense
                    hide-details="auto"
                    readonly background-color="#FFF9C4"
                  ></v-text-field>
                </v-col>

                <v-col cols="2" class="d-flex justify-center">
                  <v-btn fab small color="primary" elevation="1" @click="pesquisarCor" title="Pesquisar Cor">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Seção 2: Especificações Técnicas -->
              <div class="d-flex align-center mt-3 mb-2">
                <v-icon small color="primary" class="mr-2">mdi-car-info</v-icon>
                <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
                  ESPECIFICAÇÕES
                </span>
                <v-divider class="ml-3 divisor-secao"></v-divider>
              </div>

              <v-row dense>
                <v-col cols="10">
                  <v-text-field
                    v-model="formData.marca"
                    label="Marca"
                    outlined dense
                    hide-details="auto"
                    readonly background-color="#FFF9C4"
                  ></v-text-field>
                </v-col>

                <v-col cols="2" class="d-flex justify-center">
                  <v-btn fab small color="primary" elevation="1" @click="pesquisarMarcaVeiculo" title="Pesquisar Marca Veículo">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="8">
                  <v-text-field
                    v-model="formData.modelo"
                    label="Modelo / Submodelo"
                    outlined dense
                    type="number"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <v-col cols="4">
                  <v-text-field
                    v-model="formData.ano"
                    label="Ano"
                    outlined dense
                    hide-details="auto"
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-select
                    v-model="formData.combustivel"
                    :items="opcoesCombustivel"
                    item-text="text"
                    item-value="value"
                    label="Combustível"
                    outlined dense clearable
                    hide-details="auto"
                  ></v-select>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="formData.km"
                    label="Km Atual"
                    type="number"
                    outlined dense min="0"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="formData.motor"
                    label="Motor"
                    outlined dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Seção 3: Registros de Fábrica -->
              <div class="d-flex align-center mt-3 mb-2">
                <v-icon small color="primary" class="mr-2">mdi-barcode-scan</v-icon>
                <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
                  REGISTROS DE FÁBRICA
                </span>
                <v-divider class="ml-3 divisor-secao"></v-divider>
              </div>

              <v-row dense>
                <v-col cols="6">
                  <v-text-field
                    v-model="formData.numSerie"
                    label="Nº Série"
                    outlined dense
                    hide-details="auto"
                    maxlength="30"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="formData.chassi"
                    label="Chassi"
                    outlined dense
                    hide-details="auto"
                    maxlength="17"
                  ></v-text-field>
                </v-col>
              </v-row>

            </v-form>
          </v-card-text>

          <v-divider class="divisor-secao"></v-divider>

          <!-- Ações limpas -->
          <v-card-actions class="pa-2">
            <!-- <v-btn color="error" text @click="excluir" v-if="formData.idveiculo">
              Excluir
            </v-btn> -->
            <v-spacer></v-spacer>
            <v-btn text @click="cancelar">Cancelar</v-btn>
            <v-btn color="primary" class="px-6" @click="salvar" :disabled="!formValido">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie';

export default {
  name: 'CadastroVeiculo',

  data() {
    return {
      formValido: true,
      opcoesCombustivel: [
        { text: 'Diesel', value: 'D' },
        { text: 'Etanol', value: 'E' },
        { text: 'Flex', value: 'F' },
        { text: 'Gasolina', value: 'G' }
      ],
      formData: {
        idveiculo: null,
        placa: '',
        descricao: '',
        frota: '',
        cor: '',
        idcor: null,
        marca: '',
        idmarcaveiculo: null,
        ano: '',
        modelo: '',
        combustivel: '',
        km: '',
        motor: '',
        numSerie: '',
        chassi: ''
      }
    };
  },

  created() {
    this.$root.$on('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
    this.verificarRetornoPesquisa();
  },

  beforeDestroy() {
    this.$root.$off('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
  },

  methods: {
    tratarVoltarAppBar() {
      this.cancelar();
    },

    salvarEstadoTemporario() {
      sessionStorage.setItem('veiculoEmEdicao', JSON.stringify(this.formData));
    },

    pesquisarVeiculo() {
      this.salvarEstadoTemporario();
      this.$router.push({ name: 'veiculo'});
    },

    pesquisarCor() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/PesquisaMarcaCor', query: { tabela: 'cor' } });
    },

    pesquisarMarcaVeiculo() {
      this.salvarEstadoTemporario();
      this.$router.push({ path: '/PesquisaMarcaCor', query: { tabela: 'marcaveiculo' } });
    },

    async verificarRetornoPesquisa() {
      let veioDeEmEdicao = false;
      const estadoSalvo = sessionStorage.getItem('veiculoEmEdicao');
      if (estadoSalvo) {
        try {
          this.formData = { ...this.formData, ...JSON.parse(estadoSalvo) };
          sessionStorage.removeItem('veiculoEmEdicao');
          veioDeEmEdicao = true;
        } catch (e) {
          console.error(e);
        }
      }

      const osEmEdicaoStr = sessionStorage.getItem('osEmEdicao');
      if (osEmEdicaoStr) {
        try {
          const osEstado = JSON.parse(osEmEdicaoStr);
          if (osEstado && osEstado.formData) {
            const osForm = osEstado.formData;
            if (osForm.placa !== undefined && !veioDeEmEdicao && !this.formData.placa) {
              this.formData.placa = osForm.placa ? osForm.placa : '';
            }
            if (osForm.veiculo && !this.formData.descricao) this.formData.descricao = osForm.veiculo;
            if (osForm.km && !this.formData.km) this.formData.km = osForm.km;
            if (osForm.motor && !this.formData.motor) this.formData.motor = osForm.motor;
            if (osForm.ano && !this.formData.ano) this.formData.ano = osForm.ano;
            if (osForm.modelo && !this.formData.modelo) this.formData.modelo = osForm.modelo;
            if (osForm.combustivel && !this.formData.combustivel) this.formData.combustivel = this.normalizarCombustivel(osForm.combustivel);
            if (osForm.chassi && !this.formData.chassi) this.formData.chassi = osForm.chassi;
            if ((osForm.numSerie || osForm.prsnumeroserieequipamento) && !this.formData.numSerie) this.formData.numSerie = osForm.numSerie || osForm.prsnumeroserieequipamento;
            if (osForm.idveiculo && !this.formData.idveiculo) this.formData.idveiculo = osForm.idveiculo;
          }
        } catch (e) {
          console.error(e);
        }
      }

      if (!veioDeEmEdicao) {
        const q = this.$route.query;
        if (q.placa !== undefined && (q.placa === '' || q.placa === null)) {
          this.formData = {
            idveiculo: null,
            placa: '',
            descricao: '',
            frota: '',
            cor: '',
            idcor: null,
            marca: '',
            idmarcaveiculo: null,
            ano: '',
            modelo: '',
            combustivel: '',
            km: '',
            motor: '',
            numSerie: '',
            chassi: ''
          };
        } else {
          if (q.placa && !this.formData.placa) this.formData.placa = q.placa;
          if (q.km && !this.formData.km) this.formData.km = q.km;
          if (q.motor && !this.formData.motor) this.formData.motor = q.motor;
          if (q.ano && !this.formData.ano) this.formData.ano = q.ano;
          if (q.modelo && !this.formData.modelo) this.formData.modelo = q.modelo;
          if (q.combustivel && !this.formData.combustivel) this.formData.combustivel = this.normalizarCombustivel(q.combustivel);
          if (q.chassi && !this.formData.chassi) this.formData.chassi = q.chassi;
          if ((q.numSerie || q.prsnumeroserieequipamento) && !this.formData.numSerie) this.formData.numSerie = q.numSerie || q.prsnumeroserieequipamento;
        }
      }

      const veiculoRetorno = sessionStorage.getItem('veiculo_selecionado_retorno');
      const corRetorno = sessionStorage.getItem('cor_selecionada_retorno');
      const marcaRetorno = sessionStorage.getItem('marca_selecionada_retorno');
      const pesquisaRetorno = sessionStorage.getItem('pesquisaResultado');

      let selecionouRetorno = false;

      if (veiculoRetorno) {
        try {
          const v = JSON.parse(veiculoRetorno);
          this.preencherDadosVeiculo(v);
          selecionouRetorno = true;
          sessionStorage.removeItem('veiculo_selecionado_retorno');
          sessionStorage.removeItem('pesquisaResultado');
        } catch (e) {
          console.error(e);
        }
      } else if (corRetorno) {
        try {
          const c = JSON.parse(corRetorno);
          this.formData.cor = c.descricao || c.nome || '';
          this.formData.idcor = c.id || c.coridnuvem || c.coridcor || c.IDCOR || c.idcor || null;
          selecionouRetorno = true;
          sessionStorage.removeItem('cor_selecionada_retorno');
          sessionStorage.removeItem('pesquisaResultado');
        } catch (e) {
          console.error(e);
        }
      } else if (marcaRetorno) {
        try {
          const m = JSON.parse(marcaRetorno);
          this.formData.marca = m.descricao || m.nome || '';
          this.formData.idmarcaveiculo = m.id || m.mavidnuvem || m.mavidmarcaveiculo || m.IDMARCAVEICULO || m.IDMARCA || null;
          selecionouRetorno = true;
          sessionStorage.removeItem('marca_selecionada_retorno');
          sessionStorage.removeItem('pesquisaResultado');
        } catch (e) {
          console.error(e);
        }
      } else if (pesquisaRetorno) {
        try {
          const res = JSON.parse(pesquisaRetorno);
          if (res.tipo === 'Veiculo') {
            let v = null;
            if (res.dexieId) {
              v = await db.veiculo.get(parseInt(res.dexieId));
            }
            if (!v && (res.id || res.idveiculo)) {
              v = await this.obterVeiculoPorId(res.id || res.idveiculo);
            }
            if (!v && (res.placa || res.codigo)) {
              const placaLimpa = String(res.placa || res.codigo).trim().toLowerCase().replace(/[^a-z0-9]/g, '');
              v = await db.veiculo.filter(item => {
                const p = (item.veiplaca || item.placa || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                return p === placaLimpa;
              }).first();
            }

            if (v) {
              this.preencherDadosVeiculo(v);
            } else {
              this.formData.placa = res.placa || res.codigo || '';
              this.formData.descricao = res.descricao || res.nome || '';
              if (res.id || res.idveiculo) this.formData.idveiculo = res.id || res.idveiculo;
            }
            selecionouRetorno = true;
          } else if (res.tipo === 'Cor') {
            this.formData.cor = res.descricao || res.nome || '';
            this.formData.idcor = res.id || res.idcor || res.coridnuvem || res.coridcor || res.IDCOR || null;
            selecionouRetorno = true;
          } else if (res.tipo === 'MarcaVeiculo') {
            this.formData.marca = res.descricao || res.nome || '';
            this.formData.idmarcaveiculo = res.id || res.idmarcaveiculo || res.mavidnuvem || res.mavidmarcaveiculo || res.IDMARCAVEICULO || res.IDMARCA || null;
            selecionouRetorno = true;
          }
          sessionStorage.removeItem('pesquisaResultado');
        } catch (e) {
          console.error(e);
        }
      }

      if (!veioDeEmEdicao && !selecionouRetorno && (this.formData.idveiculo || this.formData.placa)) {
        await this.buscarVeiculoNoBanco();
      }
    },

    async obterVeiculoPorId(idVei) {
      if (!idVei) return null;
      const idNum = parseInt(idVei);
      if (isNaN(idNum)) return null;

      let v = await db.veiculo.where('veiidveiculo').equals(idNum).first();
      if (!v) {
        v = await db.veiculo.get(idNum);
      }
      if (!v) {
        v = await db.veiculo.where('veiidnuvem').equals(idNum).first();
      }
      return v;
    },

    async buscarVeiculoNoBanco() {
      try {
        let v = null;
        if (this.formData.idveiculo) {
          v = await this.obterVeiculoPorId(this.formData.idveiculo);
        }
        if (!v && this.formData.placa && this.formData.placa.trim()) {
          const placaLimpa = this.formData.placa.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
          v = await db.veiculo.filter(item => {
            const p = (item.veiplaca || item.placa || '').toLowerCase().replace(/[^a-z0-9]/g, '');
            return p === placaLimpa;
          }).first();
        }
        if (v) {
          this.preencherDadosVeiculo(v);
        }
      } catch (e) {
        console.warn("Erro ao buscar veículo no banco:", e);
      }
    },

    async buscarVeiculoPorPlacaDirect() {
      await this.buscarVeiculoNoBanco();
    },

    normalizarCombustivel(val) {
      if (!val) return '';
      const s = String(val).trim().toUpperCase();
      if (s === 'D' || s.startsWith('DIESEL')) return 'D';
      if (s === 'E' || s.startsWith('ETANOL') || s.startsWith('ALCOOL') || s.startsWith('ÁLCOOL')) return 'E';
      if (s === 'F' || s.startsWith('FLEX')) return 'F';
      if (s === 'G' || s.startsWith('GASOLINA')) return 'G';
      return val;
    },

    preencherDadosVeiculo(v) {
      if (!v) return;
      if (v.idveiculo || v.veiidveiculo || v.id) this.formData.idveiculo = v.idveiculo || v.veiidveiculo || v.id;
      if (v.placa || v.veiplaca || v.PLACA) this.formData.placa = v.placa || v.veiplaca || v.PLACA;
      if (v.descricao || v.veidescricao || v.DESCRICAO) this.formData.descricao = v.descricao || v.veidescricao || v.DESCRICAO;
      
      const marcaFinal = v.veimarcanome || v.vaimarcanome || v.MarcaDescricao || v.marcanome || v.marca || v.Marca || v.MARCA;
      if (marcaFinal) this.formData.marca = marcaFinal;
      const idMarcaFinal = v.veiidmarca || v.IDMARCA || v.idmarcaveiculo || v.mavidmarcaveiculo || null;
      if (idMarcaFinal) this.formData.idmarcaveiculo = idMarcaFinal;
      
      const corFinal = v.veicor || v.CorDescricao || v.cor || v.Cor || v.COR;
      if (corFinal) this.formData.cor = corFinal;
      const idCorFinal = v.veiidcor || v.IDCOR || v.idcor || v.coridcor || null;
      if (idCorFinal) this.formData.idcor = idCorFinal;
      
      const frotaFinal = v.veifrota || v.Frota || v.frota || v.FROTA;
      if (frotaFinal) this.formData.frota = frotaFinal;
      
      if (v.ano || v.veiano || v.ANO) this.formData.ano = v.ano || v.veiano || v.ANO;
      if (v.anoModelo || v.modelo || v.veianomodelo || v.ANOMODELO) this.formData.modelo = v.anoModelo || v.modelo || v.veianomodelo || v.ANOMODELO;
      
      const comb = v.combustivel || v.veicombustivel || v.COMBUSTIVEL;
      if (comb) this.formData.combustivel = this.normalizarCombustivel(comb);
      
      if (v.chassi || v.veichassi || v.NroCHASSI || v.prsnumerochassi) this.formData.chassi = v.chassi || v.veichassi || v.NroCHASSI || v.prsnumerochassi;
      if (v.km || v.veikm || v.KM || v.prskm) this.formData.km = v.km || v.veikm || v.KM || v.prskm;
      if (v.motor || v.veimotor || v.Motor || v.prsmotor) this.formData.motor = v.motor || v.veimotor || v.Motor || v.prsmotor;
      
      const numSerieFinal = v.numSerie || v.veinumeroserie || v.veinumserie || v.prsnumeroserieequipamento || v.NUMEROSERIE || v.NumeroSerie;
      if (numSerieFinal) this.formData.numSerie = numSerieFinal;
    },

    async salvar() {
      if (!this.formData.placa && !this.formData.descricao) {
        return;
      }
      
      try {
        const idExistente = this.formData.idveiculo || null;

        const objVeiculo = {
          veiplaca: this.formData.placa ? String(this.formData.placa).trim().toUpperCase() : '',
          veidescricao: this.formData.descricao || '',
          veimarcanome: this.formData.marca || '',
          vaimarcanome: this.formData.marca || '',
          veiidmarca: this.formData.idmarcaveiculo || null,
          veicor: this.formData.cor || '',
          veiidcor: this.formData.idcor || null,
          veifrota: this.formData.frota || '',
          veiano: this.formData.ano || '',
          veianomodelo: this.formData.modelo || '',
          veicombustivel: this.formData.combustivel || '',
          veichassi: this.formData.chassi || '',
          veinumeroserie: this.formData.numSerie || '',
          veikm: this.formData.km || '',
          veimotor: this.formData.motor || '',
          veidataalteracao: new Date().toISOString()
        };

        if (idExistente) {
          objVeiculo.veiidveiculo = idExistente;
          objVeiculo.veiidnuvem = idExistente;

          const localItem = await this.obterVeiculoPorId(idExistente);
          if (localItem) {
            await db.veiculo.update(localItem.id, objVeiculo);
            objVeiculo.id = localItem.id;
          } else {
            const addedId = await db.veiculo.add(objVeiculo);
            objVeiculo.id = addedId;
          }
        } else {
          const addedId = await db.veiculo.add(objVeiculo);
          objVeiculo.id = addedId;
        }

        const dadosParaRetorno = {
          tipo: 'Veiculo',
          codigo: this.formData.placa || this.formData.descricao,
          id: objVeiculo.veiidveiculo || objVeiculo.id,
          nome: this.formData.descricao,
          placa: this.formData.placa,
          descricao: this.formData.descricao,
          marca: this.formData.marca,
          veimarcanome: this.formData.marca,
          idmarcaveiculo: this.formData.idmarcaveiculo || null,
          veiidmarca: this.formData.idmarcaveiculo || null,
          cor: this.formData.cor,
          veicor: this.formData.cor,
          idcor: this.formData.idcor || null,
          veiidcor: this.formData.idcor || null,
          frota: this.formData.frota,
          veifrota: this.formData.frota,
          ano: this.formData.ano,
          modelo: this.formData.modelo,
          combustivel: this.formData.combustivel,
          km: this.formData.km,
          motor: this.formData.motor,
          chassi: this.formData.chassi,
          numSerie: this.formData.numSerie
        };

        sessionStorage.setItem('pesquisaResultado', JSON.stringify(dadosParaRetorno));
        sessionStorage.setItem('veiculo_selecionado_retorno', JSON.stringify(objVeiculo));

        this.$router.back();
      } catch (err) {
        console.error("Erro ao salvar veículo no Dexie:", err);
      }
    },

    async excluir() {
      if (!this.formData.idveiculo) return;
      try {
        const localItem = await this.obterVeiculoPorId(this.formData.idveiculo);
        if (localItem) {
          await db.veiculo.delete(localItem.id);
        }
        this.cancelar();
      } catch (err) {
        console.error("Erro ao excluir veículo:", err);
      }
    },

    cancelar() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formulario-wrapper {
  max-width: 560px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.border-card {
  border: 1px solid #e0e0e0;
  overflow: hidden;
}

.section-title {
  letter-spacing: 0.5px;
}

.custom-field ::v-deep .v-input__slot {
  background-color: #ffffff !important;
  transition: all 0.2s ease-in-out;
}

.custom-field ::v-deep .v-input__slot:hover {
  border-color: #1976D2 !important;
}

.custom-field ::v-deep .v-icon {
  font-size: 20px;
}

.divisor-secao {
  border-top: 1px solid #5a5a5a !important;
  border-color: #5a5a5a !important;
  opacity: 0.95;
}
</style>